import React, {Component} from 'react';
import { connect } from 'react-redux';

class Error extends Component {
  render() {
    return (
      <div className="row signup-box">
        <div className="col-md-8 col-md-offset-2">
          <div className="sing-box text-center">
            <div className="email-box">
              <div>
                <h1>Your link has expired</h1>
                Contact us : <a href="mailto:support@rifird.com">support@rifird.com</a>
              </div>
              <a href="/#/" className="btn btn-default" style={{marginTop: '30px'}}>Go to the Home page</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep
  })
)(Error);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/error_expired.js
 **/